import { useLayoutPreference } from '@/components/InvoiceReportDetailDrawer/hooks/useLayoutPreference';

export const TransactionsLayouts = {
  table: 'table',
  card: 'card',
} as const;

export type TransactionsLayout =
  (typeof TransactionsLayouts)[keyof typeof TransactionsLayouts];

const DEFAULT_LAYOUT: TransactionsLayout = TransactionsLayouts.table;

const STORAGE_KEY = 'paymentDetailDrawerTransactionsLayout:v1';

/**
 * Tracks the 支払明細 layout choice, persisted per user in localStorage
 * (NA-5531): the last-used layout is restored the next time the user
 * reopens the drawer or reloads the page. Users who never changed the
 * layout keep seeing the default (`table`).
 */
export const useTransactionsLayout = () => {
  const { layout, setLayout } = useLayoutPreference<TransactionsLayout>({
    storageKey: STORAGE_KEY,
    defaultLayout: DEFAULT_LAYOUT,
    validValues: Object.values(TransactionsLayouts),
  });

  return {
    layout,
    setLayout,
  };
};
